import React from 'react';
import { 
  HiOutlineBriefcase, 
  HiOutlineClock, 
  HiOutlineCheckCircle,
  HiOutlineCurrencyPound 
} from 'react-icons/hi2';
import styles from './Projects.module.css';

const ProjectsSummaryCards = ({ summaryData }) => {
  const formatCurrency = (amount) => {
    if (!amount) return '£0.00';
    return `£${(amount / 100).toFixed(2)}`;
  };

  const cards = [
    {
      label: 'In Progress',
      value: summaryData.inProgress,
      icon: <HiOutlineClock />,
      iconClass: styles.summaryCardIconGreen
    },
    {
      label: 'Completed',
      value: summaryData.completed,
      icon: <HiOutlineCheckCircle />,
      iconClass: styles.summaryCardIconPurple
    },
    {
      label: 'Total Value',
      value: formatCurrency(summaryData.totalValue),
      icon: <HiOutlineCurrencyPound />,
      iconClass: styles.summaryCardIconAmber
    }
  ];

  return (
    <div className={styles.summaryCards}>
      {cards.map((card, index) => (
        <div key={index} className={styles.summaryCard}>
          <div className={styles.summaryCardContent}>
            <div className={`${styles.summaryCardIcon} ${card.iconClass}`}>
              {card.icon}
            </div>
            <div className={styles.summaryCardText}>
              <p className={styles.summaryCardLabel}>{card.label}</p>
              <p className={styles.summaryCardValue}>{card.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProjectsSummaryCards;